module.exports = __webpack_public_path__ + "static/media/模块正常工作温度.521a3a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/模块正常工作温度.png
// module id = 5074
// module chunks = 0